import { ImageTypeEnum } from '@routellers/types/dist/upload/enum/image-type.enum';
import { UploadImageResponseObject } from '@routellers/types/dist/upload/upload-image.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = {
    url: string;
    type: ImageTypeEnum;
};

type ResponseData = UploadImageResponseObject;

export const uploadImageFromUrl: ApiMethodDeclaration<ParamsData, ResponseData> = ({
    url,
    type,
}) => ({
    url: '/uploads/image-from-url',
    method: 'POST',
    data: { url, type },
});
